// Calculate HMAC-SHA256 signature of a message and return it as a hex string.
export async function calculateHMAC_SHA256(key: string, message: string): Promise<string> {
  // Encode key and message as ArrayBuffers
  const encoder = new TextEncoder();
  const keyBuffer = encoder.encode(key);
  const messageBuffer = encoder.encode(message);

  // Import the key
  const cryptoKey = await crypto.subtle.importKey(
    'raw',
    keyBuffer,
    { name: 'HMAC', hash: 'SHA-256' },
    false, // not extractable
    ['sign'] // can be used for signing
  );

  // Sign the message
  const signature = await crypto.subtle.sign(
    'HMAC',
    cryptoKey,
    messageBuffer
  );

  // Convert the result to a hex string for common use cases
  const hashArray = Array.from(new Uint8Array(signature));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

  return hashHex;
}